import {Helmet} from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer, CardContent, Button, CircularProgress, Box, Skeleton, InputAdornment, InputBase, Paper,
} from '@mui/material';

import {styled} from 'styled-components';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import {StepByStepTable} from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import {Textarea} from "@mui/joy";
import {useGetDataFromDbQuery, useGetPromptQuery} from "../store/ai/aiApi";
import {AccountCircle, BubbleChart, Download} from "@mui/icons-material";
import LoadingMagic from "../components/LoadingMagic";
import Aurora from "../components/effects/Aurora";
import GradientText from "../components/GradientText";

export default function DynamicReportsPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [prompt, setPrompt] = useState('');
    const {data, error} = useGetDataFromDbQuery({prompt});

    let promptText = '';

    useEffect(() => {
        setIsLoading(false);

        document.getElementById('result').innerHTML = data?.message;
        if (error) {
            alert('Ошибка');
            console.error('Ошибка', error);
        }
    }, [data, error])

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function toDateString(date) {
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const handleSave = async () => {
        setIsLoading(true);
        window.document.getElementById('result').innerHTML = '';
        
        setPrompt(promptText);
    };

    return (
        <GeneralLayout>
            <PageTitle title={`Построение аналитических отчетов и использованием ИИ`}/>

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>

                    <Card>
                        <Aurora
                            colorStops={["#2165d1", "#94d401", "#2165d1"]}
                            blend={0.5}
                            amplitude={1.5}
                            speed={0.5}
                        />
                        <CardContent>
                            <Stack spacing={3}>
                                <Typography fontSize={'xx-large'} textAlign={'center'}>
                                    Построение отчётов с использованием
                                    <Button style={{'fontSize': '30px'}}>
                                        <GradientText
                                            colors={["#2165d1", "#94d401", "#FFAAFF"]}
                                            animationSpeed={8}
                                            showBorder={false}
                                            className="custom-class"
                                        >
                                            ИИ
                                        </GradientText>
                                    </Button>
                                </Typography>

                                <Paper elevation={3} variant={'outlined'}>
                                    <Stack spacing={2} direction={'row'} padding={'10px'}>
                                        <InputBase
                                            minRows={4}
                                            multiline
                                            onChange={(event) => {promptText = event.target.value}}
                                            sx={{ ml: 1, flex: 1 }}
                                            placeholder="Опишите отчёт детально"
                                            inputProps={{ 'aria-label': 'Опишите отчёт детально' }}
                                        />

                                        <Stack justifyContent="space-between">
                                            <Button
                                                disabled={isLoading}
                                                startIcon={isLoading ? <CircularProgress size={15}/> :
                                                    <BubbleChart/>}
                                                onClick={handleSave}>Создать</Button>
                                        </Stack>
                                    </Stack>
                                </Paper>


                                <div id={'result'}>
                                    <></>
                                </div>

                                {!isLoading
                                    ? <></>
                                    : <>
                                        <Skeleton sx={{height: 150}} animation="wave" variant="rectangular"/>
                                    </>}
                            </Stack>
                        </CardContent>
                    </Card>

                    <br/>
                </Stack>
            </Container>
        </GeneralLayout>
    );
}